import { useState, useEffect } from "react";
import axios from "axios";
import { logError } from "@/lib/logger";
import { getAuthHeaders } from "@/lib/adminAuth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DashboardHome = () => {
  const [stats, setStats] = useState({ posts: 0, inquiries: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [posts, inquiries] = await Promise.all([
          axios.get(`${API}/blog?published_only=false`, { headers: getAuthHeaders() }),
          axios.get(`${API}/inquiries`, { headers: getAuthHeaders() }),
        ]);
        setStats({ posts: posts.data.length, inquiries: inquiries.data.length });
      } catch (err) {
        logError("Failed to fetch dashboard stats", err);
      }
    })();
  }, []);

  return (
    <div data-testid="admin-dashboard-home">
      <h1 className="text-3xl font-serif text-foreground mb-8">Dashboard</h1>
      <div className="grid grid-cols-2 gap-6">
        <div className="p-8 bg-white border border-border">
          <p className="text-4xl font-serif text-[#C5A059]">{stats.posts}</p>
          <p className="text-sm font-sans text-muted-foreground mt-2">Blog Posts</p>
        </div>
        <div className="p-8 bg-white border border-border">
          <p className="text-4xl font-serif text-[#C5A059]">{stats.inquiries}</p>
          <p className="text-sm font-sans text-muted-foreground mt-2">Inquiries</p>
        </div>
      </div>
    </div>
  );
};
